import { css } from '@emotion/css';

export const buttonInput = css`
  display: none;
`;

export const uploadButton = (disableState: boolean) => css`
  pointer-events: auto !important;
  cursor: ${disableState ? 'not-allowed' : 'pointer'} !important;
`;
